<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<path class="color-solid" d="M20,6v12H4V6H20 M22,4H2v16h20V4L22,4z" />
	<rect x="5.5" y="7.5" class="color-vector" width="13" height="9" />
</svg>
</template>